export const EN = 'en';
export const DE = 'de';
export const FR = 'fr';
export const IT = 'it';

export const DEFAULT_LANGUAGE = DE;

export const LANG_LIST = [EN, DE, FR, IT];

export const LOCALE_LIST = [
  'errors',
  'courses',
  'app',
  'account',
  'assessments',
  'authorization',
  'posts',
  'post',
  'program',
  'player',
  'lectures',
  'events',
  'course',
  'books',
  'support',
];

export const LANG_LABELS = [
  {
    id: EN,
    name: 'English',
  },
  {
    id: DE,
    name: 'Deutsch',
  },
  {
    id: FR,
    name: 'Français',
  },
  {
    id: IT,
    name: 'Italiano',
  },
];
